import React, { memo } from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { config } from '../config';
import SelectCluster from '../selectCluster';

const FormFields = memo(({
  secretName,
  onSecretNameChange,
  inputError,
  secretType,
  onSecretTypeChange,
  envName,
  onEnvChange,
  projName,
  onProjChange,
  userRole,
  onClusterChange,
}) => {
  const showProjectSelect = userRole === config.roles[0] || userRole === config.roles[2];

  return (
    <Box
      sx={{
        "& > :not(style)": {
          m: 3,
          width: "40ch",
          display: "flex",
          flexDirection: "column",
        },
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        error={Boolean(inputError)}
        helperText={inputError}
        label="Secret name"
        size="small"
        type="text"
        variant="outlined"
        value={secretName}
        onChange={onSecretNameChange}
      />

      <FormControl fullWidth>
        <InputLabel size="small">Select Type</InputLabel>
        <Select
          size="small"
          value={secretType}
          label="Select type"
          onChange={onSecretTypeChange}
        >
          {config.secretTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel size="small">Select Environment</InputLabel>
        <Select
          size="small"
          value={envName}
          label="Select Environment"
          onChange={onEnvChange}
        >
          {config.environments.map((env) => (
            <MenuItem key={env.value} value={env.value}>
              {env.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {envName && (
        <SelectCluster
          onClusterChange={onClusterChange}
          label="Select Clusters"
          multiSelect={true}
          filterEnv={envName}
        />
      )}

      {showProjectSelect && (
        <FormControl fullWidth>
          <InputLabel size="small">Select Team</InputLabel>
          <Select
            size="small"
            value={projName}
            label="Select Team"
            onChange={onProjChange}
          >
            {config.projects.map((project) => (
              <MenuItem key={project.value} value={project.value}>
                {project.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
});

FormFields.displayName = 'FormFields';
export default FormFields;